var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInviteicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.132,
    height: 20,
    viewBox: "0 0 17.132 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1829",
    "data-name": "Group 1829",
    transform: "translate(-83.061 -167.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M89.2,180.482a3.578,3.578,0,1,1,0-5l1.813-1.162c.706-.453,1.41-.91,2.12-1.356a.216.216,0,0,0,.108-.3A3.565,3.565,0,1,1,97.493,175a3.473,3.473,0,0,1-3.237-.8c-.051-.043-.1-.089-.15-.133a.251.251,0,0,0-.04-.019c-.3.192-.612.389-.923.589q-1.509.969-3.018,1.938c-.1.066-.158.114-.108.261a3.487,3.487,0,0,1,0,2.272c-.035.106-.041.17.066.239q1.99,1.27,3.982,2.552c.167-.137.326-.281.5-.406a3.568,3.568,0,1,1-1.467,3.4,3.676,3.676,0,0,1,.155-1.646.167.167,0,0,0-.08-.234q-1.961-1.253-3.919-2.511A.5.5,0,0,0,89.2,180.482Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteicon);
export default __webpack_public_path__ + "static/media/inviteicon.8f25785ee5ff063006c62279fb15f7a6.svg";
export { ForwardRef as ReactComponent };